/**
 * Builds a new URL by preserving query parameters.
 * @param baseUrl The target URL
 * @param currentSearch Optional search string (e.g. "?foo=bar")
 */
export function buildUrlWithCurrentParams(baseUrl: string, currentSearch: string = window.location.search): string {
  const [path, baseQueryString = ''] = baseUrl.split('?')
  const baseParams = new URLSearchParams(baseQueryString)
  const currentParams = new URLSearchParams(currentSearch)

  Array.from(currentParams.keys()).forEach((key) => {
    if (!baseParams.has(key)) {
      currentParams.getAll(key).forEach(value => baseParams.append(key, value))
    }
  })

  const mergedQuery = baseParams.toString()
  return mergedQuery ? `${path}?${mergedQuery}` : path
}
